<script setup>
import { defineEmits, defineProps } from "vue";
import { formatter } from "@/components/program-manager/sessions/utils.js";

const emit = defineEmits(["addProduct"]);
const props = defineProps({
  product: {
    type: Object,
    default: () => {},
  },
  index: {
    type: Number,
    default: 0,
  },
});
</script>

<template>
  <div
    class="w-full rounded-lg border border-[#EAEAEA]"
    :data-testid="props.product.testId + '-card'"
  >
    <div class="bg-[#E5F2F2] flex py-2 px-4 justify-between items-baseline">
      <p class="font-semibold text-gray-700 text-sm">
        {{ props.product.type }}
      </p>
      <button
        class="font-bold text-sm text-teal-900 flex items-cente"
        :class="[
          secondaryColor
            ? `${secondaryColorClass}`
            : `${secondaryColorClass} hover:text-teal-900 focus:text-teal-900`,
        ]"
        :disabled="props.product.disabled"
        :data-testid="props.product.testId + 'add-button'"
        @click="emit('addProduct', { product: props.product, index: index })"
      >
        <span class="uppercase">+ Add</span>
      </button>
    </div>
    <div class="min-w-full">
      <img
        :src="'/images/' + props.product.image"
        class="select-none w-full h-full object-cover object-center"
      />
    </div>
    <div class="py-2 px-4 text-indigo-base">
      <p class="font-semibold text-sm pb-2">{{ props.product.title }}</p>
      <p class="text-xs font-semibold text-black">
        Available until {{ props.product.deadlineDate }} .
      </p>
      <p class="text-xs font-medium pb-2 text-black">
        {{ props.product.description }}
      </p>
      <div
        class="flex items-center"
        :class="props.product.canceled ? 'justify-between' : 'justify-end'"
      >
        <div v-if="props.product.canceled" class="flex items-center">
          <img src="/images/icon-cancellation.svg" />
          <span class="font-medium text-xs">Canceled</span>
        </div>
        <p class="font-bold text-sm">
          {{ formatter.format(props.product.price / 100) }}
        </p>
      </div>
    </div>
  </div>
</template>
